"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.liveEventsStatuses = exports.lineEventsStatuses = exports.EventTypeWithDefaultName = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
var EventTypeWithDefaultName;
(function (EventTypeWithDefaultName) {
    EventTypeWithDefaultName["Main"] = "Main";
})(EventTypeWithDefaultName || (exports.EventTypeWithDefaultName = EventTypeWithDefaultName = {}));
exports.lineEventsStatuses = [
    betweb_openapi_axios_1.EventStatus.Trading,
    betweb_openapi_axios_1.EventStatus.Suspended,
    betweb_openapi_axios_1.EventStatus.Open,
    betweb_openapi_axios_1.EventStatus.Planning,
];
exports.liveEventsStatuses = [
    betweb_openapi_axios_1.EventStatus.Trading,
    betweb_openapi_axios_1.EventStatus.Suspended,
];
//# sourceMappingURL=constants.js.map